import React from 'react';
import Button from '../../../../generic-components/Button';
import { CategoriesItem } from '../../types/categoriesItem';

interface LabelBubbleProps {
  item: CategoriesItem;
  isActive: boolean;
  onItemClick: (item: CategoriesItem) => void;
}

export const LabelBubble = ({ item, onItemClick, isActive }: LabelBubbleProps) => (
  <div key={item.categoryId} data-testid={`LabelBubble__wrapper__${item.categoryId}`}>
    <Button
      className=''
      id={`LabelBubble__${item.categoryId}`}
      testId={`LabelBubble__${item.categoryId}`}
      onClick={() => onItemClick(item)}
      childElement={(
        <div
          className={`min-w-[140px] flex items-center px-[8px] py-[4px] font-metricR text-[12px] rounded-[20px] border-[1px] border-bw03 mb-[8px] cursor-pointer ${isActive && 'bg-bw02'}`}
        >
          <div style={{ backgroundColor: item.color }} className='w-[8px] h-[8px] rounded-full mr-[8px]' />
          <span className='inline-block text-left' data-testid={`LabelBubble__${item.categoryId}__title`}>{item.title}</span>
        </div>
            )}
    />
  </div>
);
